import React, { Component } from 'react';
import routerActions from 'app/routerActions';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { api, apiUtils } from 'app/services';
import classNames from 'classnames';
import { KBPopover, KBTableWithoutData } from 'components';
import MemberRow from './MemberRow';
import PropTypes from 'prop-types';

var MemberList = class extends React.Component {render()
  {
    const { members, departments, department, dismissMember, refreshMember } = this.props;

    var memberList = Object.assign([], members);

    return (
      <table className="content-table" style={{ whiteSpace: 'nowrap' }}>
        <thead>
          <tr>
            <th>姓名</th>
            <th>联系方式</th>
            <th>部门</th>
            <th>状态</th>
            <th />
          </tr>
        </thead>
        <KBTableWithoutData
        hasData={memberList.length > 0}
        tableHeadNum="8"
        tipMessage="暂无员工信息">

          {memberList &&
          memberList.map((member, index) =>
          <MemberRow
          departments={departments}
          members={members}
          member={member}
          deleteMember={this.props.deleteMember}
          dismissMember={dismissMember}
          key={member.id || `member-${index}`}
          refreshMember={refreshMember} />)}


        </KBTableWithoutData>
      </table>);

  }};


MemberList.propTypes = {
  members: PropTypes.array.isRequired,
  departments: PropTypes.array.isRequired,
  deleteMember: PropTypes.func.isRequired,
  dismissMember: PropTypes.func.isRequired,
  refreshMember: PropTypes.func.isRequired };


export default MemberList;
